module.exports = __webpack_public_path__ + "img/soundcloud-head.b379733e.png";